"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NormalizedSignalDriveModesFormDefinition = exports.NormalizedSignalDriveModesFormOutputSchema = exports.NormalizedSignalDriveModesFormInputSchema = void 0;
const z = require("zod");
const misc_1 = require("../../../misc");
const form_schemas_1 = require("./form-schemas");
const payload_1 = require("./payload");
exports.NormalizedSignalDriveModesFormInputSchema = payload_1.NormalizedSignalDriveModesFormPayloadSchema.extend({
    datasheetFileId: z.string(),
    manufacturerPartNumber: z.string(),
    sequenceGate: misc_1.sequenceGateSchema,
});
exports.NormalizedSignalDriveModesFormOutputSchema = payload_1.NormalizedSignalDriveModesFormPayloadSchema.extend({
    rawFormData: form_schemas_1.NormalizedSignalDriveModesFormDataSchema.optional().catch(undefined),
});
exports.NormalizedSignalDriveModesFormDefinition = {
    type: 'NormalizedSignalDriveModesForm',
    displayName: 'Normalized signal drive modes',
    inputSchema: exports.NormalizedSignalDriveModesFormInputSchema,
    outputSchema: exports.NormalizedSignalDriveModesFormOutputSchema,
};
//# sourceMappingURL=step-definition.js.map